// This import loads the firebase namespace along with all its type information.
import ContentCreatorInvitation from './content-creator-invitation-model'

export async function load_contentCreatorInvitations(): Promise<
  ContentCreatorInvitation[]
> {
  throw 'Not implemented'
}

export async function delete_contentCreatorInvitation(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_contentCreatorInvitation(): Promise<ContentCreatorInvitation> {
  throw 'Not implemented'
}
